import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { navItems } from '../../_nav';
import { SpinnerService } from '../../common/spinner.service';
import { AdminService } from '../../admin/admin.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public show_side_menu = true;
  public navItems: any = [];
  userRole:any;
  constructor(private router: Router, private route: ActivatedRoute,private spinner: SpinnerService,private adminService: AdminService,private toastr: ToastrService,) {

  }

  ngOnInit() {
    let role = localStorage.getItem('role');
    if(role){
      this.userRole = role;
    }

    var title = this.route.snapshot.data['title'];
    if(title == 'Member'){
      this.show_side_menu = false;
    }
   // debugger
    var navVal: any = [];
    navItems.forEach(function (val, index) {
      if (title == 'Member' || title == 'Result') {
        if (val.member && !val.admin) {
          navVal.push(val);
        }
      }
      if (title == 'Admin') {
        if (!val.member && val.admin) {
          navVal.push(val);
        }
      }
    });
    this.navItems = navVal;
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  logout() {
    localStorage.removeItem('token');
    this.router.navigate(['/']);
  }


  confirmTruncateTables() {
    if (confirm('WARNING: This will DELETE ALL DATA from multiple tables. This action cannot be undone. Are you absolutely sure?')) {
      this.truncateTables();
    }
  }

  /**
   * Truncate database tables
   */
  truncateTables() {
    this.spinner.showSpinner();
    this.adminService.post('truncate-tables', {}).subscribe({
      next: (res: any) => {
        this.spinner.hideSpinner();
        if (res.status === 'OK') {
          this.toastr.success(res.message || 'Database cleared successfully');
          location.reload()
        } else {
          this.toastr.error(res.error || 'Failed to clear database');
        }
      },
      error: (err) => {
        this.spinner.hideSpinner();
        console.error('Error truncating tables:', err);
        this.toastr.error(err.error?.error || 'Failed to clear database');
      }
    });
  }


  confirmClearTieData() {
  if (confirm('This will reset tie-related data but keep organizations intact. Proceed?')) {
    this.clearTieData();
  }
}

clearTieData() {
  this.spinner.showSpinner();
  this.adminService.post('clear-tie-data', {}).subscribe({
    next: (res: any) => {
      this.spinner.hideSpinner();
      if (res.status === 'OK') {
        this.toastr.success(res.message || 'Tie data cleared successfully');
        location.reload();
      } else {
        this.toastr.error(res.error || 'Failed to clear tie data');
      }
    },
    error: (err) => {
      this.spinner.hideSpinner();
      console.error('Error clearing tie data:', err);
      this.toastr.error(err.error?.error || 'Failed to clear tie data');
    }
  });
}

}
